import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button';
import { useSetMyPlaylistLikeRating } from 'actions/playlists';
import { jsx as _jsx } from "react/jsx-runtime";
export default function LikeButton(_ref) {
  var playlist = _ref.playlist;
  var isLiked = playlist === null || playlist === void 0 ? void 0 : playlist.user_rated_like;
  var _useSetMyPlaylistLike = useSetMyPlaylistLikeRating({
      playlistId: playlist.id,
      isLiked: !isLiked
    }),
    updateMyPlaylistLikeRating = _useSetMyPlaylistLike.updateMyPlaylistLikeRating,
    isPending = _useSetMyPlaylistLike.isPending;
  var _useTranslation = useTranslation(),
    _useTranslation2 = _slicedToArray(_useTranslation, 1),
    t = _useTranslation2[0];
  return /*#__PURE__*/_jsx(Button, {
    align: "left",
    variant: "transparent",
    icon: "like",
    onClick: function onClick() {
      return updateMyPlaylistLikeRating();
    },
    isActive: isLiked,
    isDisabled: !playlist,
    isLoading: isPending,
    children: t('actions_like')
  });
}